import {useState} from "react";

// Components

// Images

// Scss
// import '../assets/css/partnerProgram.scss';
import '../assets/css/partnerPortal/welcome.scss';

import ContactRow from "./ContactRow";
import Contact from "../models/common/Contact";


function ContactSection(props) {


  const [contactList] = useState<Array<Contact>>(props.contactList);

  function addContactList() {
    return contactList.map(c => <ContactRow name={c.name} title={c.title} email={c.email} phoneNumber={c.phoneNumber} />);
  }

  return (
    <>  
        <div>
            {addContactList()}
        </div>
            
    </>
  );


}

export default ContactSection;

